import { render, staticRenderFns } from "./DetalleNivelesDisponibles.vue?vue&type=template&id=cb089f9c&"
import script from "./DetalleNivelesDisponibles.vue?vue&type=script&lang=js&"
export * from "./DetalleNivelesDisponibles.vue?vue&type=script&lang=js&"
import style0 from "./DetalleNivelesDisponibles.vue?vue&type=style&index=0&id=cb089f9c&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports